import React from "react";
import { CheckCircle2 } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";

interface FairDealBadgeProps {
  approved?: boolean | null;
  size?: "sm" | "md";
}

export function FairDealBadge({ approved, size = "md" }: FairDealBadgeProps) {
  if (approved !== true) return null;

  const iconSize = size === "sm" ? 12 : 14;

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Badge variant="outline" className={`bg-blue-100 text-blue-800 border-blue-200 hover:bg-blue-100 ${size === "sm" ? "text-xs px-1.5 py-0" : "text-xs px-2 py-0.5"} font-medium gap-1 cursor-default`}>
            <CheckCircle2 size={iconSize} />
            <span>Fair Deal</span>
          </Badge>
        </TooltipTrigger>
        <TooltipContent>
          <p className="font-medium">Fair Deal Approved</p>
          <p className="text-xs text-muted-foreground">Approved under the Nursing Homes Support Scheme</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
